export default __webpack_public_path__ + "static/media/no-image.5ad56094.png";